import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitScheduledModel } from '@apps-common/types/portal/unit-scheduled'

export const QUERY_KEY_GET_UNIT_SCHEDULE = (scheduledId?: number) => ['getUnitScheduled', scheduledId].filter(Boolean)

const getUnitScheduled = async (scheduledId: number): Promise<IUnitScheduledModel> =>
  axios.get(`/unitscheduled/getscheduled?scheduledId=${scheduledId}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitScheduled

type Props = {
  config?: QueryConfig<QueryFnType>
  scheduledId: number
}

export const useGetUnitScheduled = ({ config, scheduledId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_GET_UNIT_SCHEDULE(scheduledId),
    queryFn: () => getUnitScheduled(scheduledId)
  })
